import moment from 'moment';

export const OS_STATUS_LABELS = {
  ABERTA: 'Aberta',
  AGUARDANDO_MATERIAL: 'Aguard. material',
  EM_ATENDIMENTO: 'Em atendimento',
  AGUARDANDO_VALIDACAO: 'Aguard. validação',
  FINALIZADA: 'Finalizada',
  CANCELADA: 'Cancelada',
};

export const OS_STATUS_BADGE = {
  ABERTA: 'os-badge--blue',
  AGUARDANDO_MATERIAL: 'os-badge--amber',
  EM_ATENDIMENTO: 'os-badge--violet',
  AGUARDANDO_VALIDACAO: 'os-badge--teal',
  FINALIZADA: 'os-badge--green',
  CANCELADA: 'os-badge--gray',
};

export const TICKET_STATUS_LABELS = {
  ABERTO: 'Aberto',
  EM_ANDAMENTO: 'Em andamento',
  FINALIZADO: 'Finalizado',
};

export const TICKET_STATUS_BADGE = {
  ABERTO: 'ticket-badge--blue',
  EM_ANDAMENTO: 'ticket-badge--violet',
  FINALIZADO: 'ticket-badge--green',
};

export function getErroId(notification) {
  return notification.id_erro || notification.id || null;
}

export function ordenarNotificacoes(notifications) {
  return [...notifications].sort((a, b) => {
    const dateA = new Date(`${a.data_erro}T${a.hora_erro}`);
    const dateB = new Date(`${b.data_erro}T${b.hora_erro}`);
    return dateB - dateA;
  });
}

export function getGrupoLabel(notification) {
  if (notification.nome_grupo_fisico) return notification.nome_grupo_fisico;
  if (notification.grupo_fisico_descricao) return notification.grupo_fisico_descricao;
  if ((notification.grupo_fisico_id !== null && notification.grupo_fisico_id !== undefined) && notification.grupo_fisico_id !== '') {
    return `Grupo ${notification.grupo_fisico_id}`;
  }
  return '—';
}

export function getEnderecoControlador(notification) {
  return notification.endereco || notification.cruzamento || '';
}

export function buildTicketDataFromNotification(notification) {
  return {
    titulo: `Erro no Controlador ${notification.numero_controlador}`,
    descricao: `Mensagem de Erro: ${notification.mensagem}\n\nDetalhes:\n- Data: ${moment(
      notification.data_erro,
    ).format('DD/MM/YYYY')}\n- Hora: ${notification.hora_erro}\n- Controlador: ${
      notification.numero_controlador
    }\n- Grupo Físico: ${notification.grupo_fisico_id}`,
    grupo_fisico_id: notification.grupo_fisico_id,
    numero_controlador: notification.numero_controlador,
    controlador_erro_id: getErroId(notification),
    isFromError: true,
    controlador_id: '',
  };
}
